import { motion } from "framer-motion";
import { MailOpen, CornerDownRight } from "lucide-react";
import { ITEMS } from "./briefData";

export function BriefView({ onPick }) {
  return (
    <div data-testid="brief-view">
      <div className="flex items-center gap-2 mb-3">
        <MailOpen size={16} className="text-[#0B3D5C]" />
        <span className="font-mono-spec text-[11px] text-[#4A4A4A]">
          From: atlas@leadriver.ai
        </span>
      </div>
      <h3 className="font-sans-tight font-extrabold text-[clamp(1.3rem,2.2vw,1.8rem)] tracking-tight text-[#1A1A1A] leading-tight">
        Your morning brief — 7 things, 4 minutes
      </h3>
      <p className="font-serif-body text-[#4A4A4A] mt-3 text-[15px] leading-relaxed">
        Good morning, Tom. Here's what hit overnight. Drafts are ready —
        scan, tweak, and send.
      </p>

      <div className="mt-6 space-y-2">
        {ITEMS.map((it, i) => (
          <motion.button
            key={it.id}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 + i * 0.06, duration: 0.4 }}
            onClick={() => onPick(it.id)}
            data-testid={`brief-item-${it.id}`}
            className="w-full text-left p-3 border border-[#E5E0D8] hover:border-[#0B3D5C] bg-white transition-colors flex items-start gap-3 group"
          >
            <span
              className="mt-1 text-[10px] font-sans-tight font-bold uppercase tracking-wider px-2 py-1 text-white"
              style={{ background: it.pillColor }}
            >
              {it.pill}
            </span>
            <div className="flex-1 min-w-0">
              <p className="font-sans-tight font-semibold text-[14px] text-[#1A1A1A] truncate">
                {it.title}
              </p>
              <p className="font-serif-body text-[12.5px] text-[#4A4A4A] mt-0.5">
                {it.meta}
              </p>
            </div>
            <CornerDownRight
              size={14}
              className="text-[#4A4A4A] group-hover:text-[#E07B3A] transition-colors mt-1"
            />
          </motion.button>
        ))}
      </div>
    </div>
  );
}
